<div class="actionItemAuditSection">
    <app-action-item-audit-life-cycle *ngIf="isActionItemAuditDetailsDataLoaded && !showLoader"
        [auditLifecycleInput]="actionItemLifeCycleDetails">
    </app-action-item-audit-life-cycle>
    <p-fieldset legend="Audit Trail" *ngIf="isActionItemAuditDetailsDataLoaded && !showLoader">
        <div class="grid">
            <div class="col-6">
                <app-action-item-audit-summary [auditSummaryDetails]="actionItemAuditSummaryDetails"
                    (attributeDetailsOfTransaction)="showAuditItemDetails($event)"></app-action-item-audit-summary>
            </div>
            <div class="col-6 auditTrialDetailsSection">
                <app-audit-item-details
                    [auditTrialDetails]="auditAttributeDetailsOfTransaction"></app-audit-item-details>
            </div>
        </div>
    </p-fieldset>

</div>
